import { AppState } from 'redux/reducers';

export const getIsConnectedGeneral = ({ webSocket }: AppState) => webSocket.isConnectedGeneralWebSocket;
export const getSubscribeToGeneralMessages = ({ webSocket }: AppState) => webSocket.subscribeToGeneralMessages;
export const getIsConnectedAsianViewGeneral = ({ webSocket }: AppState) =>
  webSocket.isConnectedAsianViewGeneralWebSocket;
export const getSubscribeToAsianViewGeneralMessages = ({ webSocket }: AppState) =>
  webSocket.subscribeToAsianViewGeneralMessages;
